import Vue from 'vue';
import CsokCalculator from './csok-calculator/csok-calculator.vue';
Vue.component('csok-calculator', CsokCalculator);
